const Api = {
  GRID: 'https://geospatialresearch.mtu.edu/grid.php',
  GRID_CELL: 'https://geospatialresearch.mtu.edu/grid_cell.php',
  MARKERS: 'https://geospatialresearch.mtu.edu/markers.php',
  MARKER_INFO: 'https://geospatialresearch.mtu.edu/marker_info.php',
  MAP_PICKER: 'https://geospatialresearch.mtu.edu/map_picker.php',
  LIST: 'https://geospatialresearch.mtu.edu/list.php',
  FULL_DETAILS: 'https://geospatialresearch.mtu.edu/full_details.php',
  RELATED_CONTENT: 'https://geospatialresearch.mtu.edu/related_content.php',
  DATE_PICKER: 'https://geospatialresearch.mtu.edu/date_picker.php',
  FLAG: 'https://geospatialresearch.mtu.edu/flag.php',
  PLACE_NAME: 'https://portal1-geo.sabu.mtu.edu/server/rest/services/KeweenawHSDI/cchsdi_placenames/FeatureServer/0/query',
  STORY_SUBMIT: 'https://portal1-geo.sabu.mtu.edu:6443/arcgis/rest/services/KeweenawHSDI/story_pts_watts2/FeatureServer/0'
};
const VideoUrls = {
  SEARCH_FILTERS: 'https://www.youtube.com/embed/RbSeH4kWHnc',
  SEARCH_DETAILS: 'https://www.youtube.com/embed/B2VmTPoVpQU',
  EXPLORE: 'https://www.youtube.com/embed/aVJa22NF1-g',
  CONTROLS: 'https://www.youtube.com/embed/ZP6lmPCoXtw',
};
export { Api, VideoUrls };
